/**
 * WebSocket endpoint configuration.
 *
 * SockJS endpoint is registered at `/ws` on the same API host as REST calls.
 * STOMP topics are subscribed after connect; this URL is only the transport layer.
 */

const API_BASE_URL_DEV = "https://nd06.truliacare.com/pdvapi/niramayafoundation/ws";

export const SOCKET_ENDPOINT_URL = API_BASE_URL_DEV;

export const SOCKET_TOPICS = {
  user: (userIdentifier) => `/topic/user/${userIdentifier}`,
  room: (roomId) => `/topic/room/${roomId}`,
};

/** Spring STOMP application destination for typing events. */
export const SOCKET_APP_DESTINATIONS = {
  typing: (roomId) => `/app/chat/room/${roomId}/typing`,
};

export const TYPING_INDICATOR_TIMEOUT_MS = 3000;
